import { connect } from 'react-redux'
import {changeLabel} from '../actions'
import MyLabels from '../components/MyLabels'

const mapStateToProps = (state) => {
    return state.poster.labels;
}

const mapDispatchToProps = (dispatch) => {
    return {
        onChangeLabel: (key,value) => {
            dispatch(changeLabel(key,value));
        }
    }
}

const RxMyLabels = connect(
    mapStateToProps,
    mapDispatchToProps
)(MyLabels)

export default RxMyLabels


// WEBPACK FOOTER //
// ./src/containers/RxMyLabels.js